module.exports = __webpack_public_path__ + "img/icon-chat.82f38bf.svg";